var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.renderGrid) ? _c('div', {
    staticClass: "jqx_grid_wrapper",
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "id": _vm.name + 'Father'
    }
  }, [(_vm.displayedTitle != null) ? _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.displayedTitle)
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    attrs: {
      "id": _vm.name
    }
  }), _vm._v(" "), (_vm.textPopup) ? _c('text-modifier', {
    attrs: {
      "effect": "fade",
      "placement": "left",
      "popoverStyle": _vm.popoverStyle,
      "arrowStyle": _vm.arrowStyle,
      "title": _vm.popupTitle,
      "content": _vm.popupContent,
      "popoverCondition": _vm.popoverCondition,
      "value": _vm.initialValue,
      "placeholder": this.$Jed.firstUpperTranslate('insert text'),
      "validation": _vm.validation,
      "fixedTop": _vm.topPos,
      "fixedLeft": _vm.leftPos
    },
    on: {
      "confirm": _vm.editEndCallback
    }
  }, [_c('span', {
    staticStyle: {
      "position": "fixed"
    },
    style: ({
      left: _vm.leftPos + 'px',
      top: _vm.topPos + 'px'
    }),
    attrs: {
      "id": _vm.guid
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.selectionPopup) ? _c('selector-modifier', {
    attrs: {
      "effect": "fade",
      "placement": "right",
      "choices": _vm.editSelectOptions,
      "fieldValue": "value",
      "fieldLabel": "label",
      "fixedTop": _vm.topPos,
      "fixedLeft": _vm.leftPos,
      "title": "Prova Popup Selector",
      "content": "Select generica",
      "validation": _vm.validation,
      "value": _vm.initialValue,
      "placeholder": "Scegli una delle opzioni"
    },
    on: {
      "confirm": _vm.editEndCallback
    }
  }, [_c('span', {
    staticStyle: {
      "position": "fixed"
    },
    style: ({
      left: _vm.leftPos + 'px',
      top: _vm.topPos + 'px'
    }),
    attrs: {
      "id": _vm.guid
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.numberPopup) ? _c('number-modifier', {
    attrs: {
      "effect": "fade",
      "placement": "right",
      "title": "Prova Popup Number Editor",
      "content": "Popup generico per la modifica di un intero",
      "fixedTop": _vm.topPos,
      "fixedLeft": _vm.leftPos,
      "value": _vm.initialValue,
      "placeholder": "Inserisci Numero Intero",
      "validation": _vm.validation
    },
    on: {
      "confirm": _vm.editEndCallback
    }
  }, [_c('span', {
    staticStyle: {
      "position": "fixed"
    },
    style: ({
      left: _vm.leftPos + 'px',
      top: _vm.topPos + 'px'
    }),
    attrs: {
      "id": _vm.guid
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.datePopup) ? _c('date-modifier', {
    attrs: {
      "effect": "fade",
      "placement": "right",
      "title": "Prova Popup Date Editor",
      "content": "Popup generico per la modifica di un campo data",
      "fixedTop": _vm.topPos,
      "fixedLeft": _vm.leftPos,
      "value": _vm.initialValue,
      "validation": _vm.validation
    },
    on: {
      "confirm": _vm.editEndCallback
    }
  }, [_c('span', {
    staticStyle: {
      "position": "fixed"
    },
    style: ({
      left: _vm.leftPos + 'px',
      top: _vm.topPos + 'px'
    }),
    attrs: {
      "id": _vm.guid
    }
  })]) : _vm._e(), _vm._v(" "), _c('help-popover', {
    attrs: {
      "helpProp": _vm.name,
      "reference": _vm.name,
      "msg": _vm.helperMsg,
      "offset": {
        top: -50
      }
    }
  })], 1) : _vm._e()
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-65c19cc0","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dynamic/jqwGridWrapper/jqwGridWrapper.vue
// module id = 1571
// module chunks = 1